module.exports = __webpack_public_path__ + "assets/img/busy_5.20d5def0.png";